import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

type HotkeysDialogContextType = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const HotkeysDialogContext = createContext<HotkeysDialogContextType | undefined>(undefined);

export function HotkeysDialogProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const value = useMemo(() => ({ isOpen, setIsOpen }), [isOpen]);

  return <HotkeysDialogContext.Provider value={value}>{children}</HotkeysDialogContext.Provider>;
}

export function useHotkeysDialog() {
  const context = useContext(HotkeysDialogContext);
  if (!context) {
    throw new Error('useHotkeysDialog must be used within a HotkeysDialogProvider');
  }
  return context;
}
